<template>
  <half-circle-spinner
      class="spinner"
      :animation-duration="1000"
      :size="60"
      color="#3d3df3"
  />
</template>

<script>
  import { HalfCircleSpinner } from 'epic-spinners';

  export default {
    components: {
      HalfCircleSpinner
    }
  }
</script>

<style scoped>
  .spinner {
    position: absolute;
    top: calc(50% - 40px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }
</style>